import PropTypes from 'prop-types';

import { NS } from '@/constants';
import { useAppDispatch } from '@/redux';
import { resetForm } from '@/redux/slices/form.slice';
import { carouselProductsToSlidesProps } from '@/utils/millesimaUtils';

import TopCategory from '@/components/categ/TopCategory';
import ProductRecoCarousel from '@/components/layout/carouselV3/ProductRecoCarousel';
import DynamicLayout from '@/components/layout/DynamicLayout';
import ContactForm from '@/components/search/ContactForm';

import styles from './NoSearchResult.module.scss';
import { CONTACT_FORM_OPTIONS, CONTACT_FORM_TYPES } from '@/constants/contact';

export const keyPrefix = 'noSearchResult.contactForm';

const NoSearchResult = ({ t, topCategory, products, searchTerm, isMobileView, espot }) => {
  const dispatch = useAppDispatch();

  const handleConfirm = () => {
    dispatch(resetForm());
  };

  return (
    <div className={styles.container}>
      <div className={`${styles.body} ${isMobileView ? styles.column : ''}`}>
        {topCategory && (
          <div className={styles['top-category']}>
            <TopCategory t={t} topCategory={topCategory} isMobileDevice={isMobileView} />
          </div>
        )}
        <div className={styles.content}>
          {searchTerm && (
            <>
              <div className={styles['no-matching-item']} data-test-id="no-matching-item">
                <div className={styles['no-matching-item-title']} data-test-id="no-matching-item-title">
                  {t('category:noSearchResult.noMatchingItem.title', { searchTerm })}
                </div>
                <span className={styles['no-matching-item-subTitle']} data-test-id="no-matching-item-subtitle">
                  {t('category:noSearchResult.noMatchingItem.subTitle')}
                </span>
              </div>
              <div className={styles['contact-form']}>
                <ContactForm
                  t={t}
                  subject={t('category:results.singular')}
                  onConfirm={handleConfirm}
                  title={t(`${keyPrefix}.title`, { ns: NS.CATEG })}
                  subtitle={t(`${keyPrefix}.subtitle`, { ns: NS.CATEG })}
                  submitLabel={t(`${keyPrefix}.submit`, { ns: NS.CATEG })}
                  options={CONTACT_FORM_OPTIONS.noSearchResult(t(`${keyPrefix}.textArea.comment`, { searchTerm, ns: NS.CATEG }))}
                  type={CONTACT_FORM_TYPES.NO_SEARCH_RESULT}
                />
              </div>
            </>
          )}
        </div>
      </div>

      <DynamicLayout componentList={[{ espot }]} isMobileDevice={isMobileView} />

      {products?.length > 0 && (
        <ProductRecoCarousel
          withGap
          slides={carouselProductsToSlidesProps({ products })}
          title={t('product.recommendations')}
          position="productView"
        />
      )}
    </div>
  );
};

NoSearchResult.propTypes = {
  t: PropTypes.func.isRequired,
  topCategory: PropTypes.array,
  products: PropTypes.array,
  searchTerm: PropTypes.string,
  espot: PropTypes.object,
  isMobileView: PropTypes.bool
};

export default NoSearchResult;
